import { startCase } from 'lodash';

const genderLabels = {
  men: `Men's`,
  women: `Women's`,
  unisex: `Unisex`,
  child: `Grade School`,
  infant: `Infant`,
  preschool: `Preschool`,
  toddler: 'Toddler',
};

export const getSizeTypeLabel = (category, gender, hideNonGender = false) => {
  if (
    !category ||
    (hideNonGender &&
      ['trading cards', 'collectibles', 'electronics'].includes(category))
  ) {
    return '';
  }

  // Trading Cards, Collectibles, and Electronics don't have gendered labels
  // Accessories are only gendered for adults
  // There is no Unisex Apparel label
  if (
    ['trading cards', 'collectibles', 'electronics'].includes(category) ||
    (category === 'accessories' &&
      ['child', 'infant', 'preschool', 'toddler'].includes(gender)) ||
    (category === 'apparel' && gender === 'unisex')
  ) {
    return startCase(category);
  }

  if (category === 'apparel') {
    return ['child', 'infant', 'preschool', 'toddler'].includes(gender)
      ? `Kids ${startCase(category)}`
      : `${genderLabels[gender]} ${startCase(category)}`;
  }

  return `${genderLabels[gender]} ${startCase(category)}`;
};
